import InfiniteScroll from 'react-infinite-scroll-component'
import Card from 'react-bootstrap/Card'
import { Blog } from 'src/@shared/types/cms/blog'
import Link from 'next/link'
import shortMonthDateBlog from 'src/@shared/functions/dateFormat'
import Image from 'next/image'

import ListLoader from '@atk/components/loaders/ListLoader/ListLoader'

import FramerMotion from '@atk/hooks/framerMotion'

import styles from './BlogHorizontal.module.scss'

export type FeaturedBoxProps = {
    list: Blog[]
    isLoading: boolean
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    hasNextPage: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fetchNextPage?: any
    customClass?: string
    desc?: boolean
    date?: boolean
    footer?: boolean
    withoutFeatured?: boolean
}

export default function BlogHorizontal({
    list,
    isLoading,
    hasNextPage,
    fetchNextPage,
    customClass,
    desc,
    date,
    footer,
    withoutFeatured,
}: FeaturedBoxProps) {
    const componentClass = `BlogHorizontal ${customClass ?? ''}`

    const blogList = list as Blog[]
    return (
        <div className={componentClass}>
            <InfiniteScroll
                className={styles.overflow}
                dataLength={blogList ? blogList.length : 0} //This is important field to render the next data
                next={() => fetchNextPage()}
                hasMore={hasNextPage || isLoading}
                loader={<ListLoader />}
                scrollThreshold={0.5}
            >
                <div className={styles.masonryWrapper}>
                    {blogList &&
                        blogList.map((p: Blog, index: number) => (
                            <div key={p._id} className={index === 0 && !withoutFeatured ? 'd-none' : ''}>
                                <FramerMotion>
                                    <Link
                                        className="text-decoration-none"
                                        href={p.externalLink ?? `/blog/${p.meta.slug}`}
                                        legacyBehavior
                                        passHref
                                    >
                                        <a
                                            className={styles.cardLink}
                                            target={p.externalLink ? '_blank' : '_self'}
                                            rel="noopener noreferrer"
                                        >
                                            <Card className={styles.blogItem}>
                                                <Image
                                                    src={p.webpThumbnailUrl ?? ''}
                                                    alt="Casper Labs"
                                                    fill
                                                    className="card-img-top position-relative"
                                                />
                                                <Card.Body>
                                                    <p className="half-title categoryName">{p.categoryName ?? ''}</p>
                                                    <Card.Title>{p.title}</Card.Title>
                                                    {desc && (
                                                        <Card.Text
                                                            dangerouslySetInnerHTML={{ __html: p.preview ?? '' }}
                                                        ></Card.Text>
                                                    )}
                                                    {date && (
                                                        <p className="date">{`${p.legendDate ?? ''}${shortMonthDateBlog(
                                                            p.timePublished
                                                        )}`}</p>
                                                    )}
                                                </Card.Body>
                                                {footer && (
                                                    <Card.Footer>
                                                        <small className="text-muted">{p.state}</small>
                                                    </Card.Footer>
                                                )}
                                            </Card>
                                        </a>
                                    </Link>
                                </FramerMotion>
                            </div>
                        ))}
                </div>
            </InfiniteScroll>
        </div>
    )
}
